/**
 * /admin/documents — firm-wide documents view (route shell).
 * Screen impl in `./documents-screen.tsx`, lazy-loaded (doc-organization,
 * G1/G2/G3/G4): the whole-book documents list + Unfiled toggle + filename
 * search + per-doc "Assign to trust". Mirrors the document-coverage shell.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/documents')({
  component: lazyRouteComponent(() => import('./documents-screen'), 'FirmDocumentsBoard'),
});
